import { ConfirmationDialog, IconButton, Id, useBulkEdit, useOpen, usePaginatedList } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useContactUpdateInquiryContactActions } from "./useContactUpdateInquiryContactActions";

interface Props {
	contactUpdateInquiryId: Id;
	activeContactFilterId: Id | null;
}

export const PendingFeedbackContactsBulkEditAction: FC<Props> = ({ contactUpdateInquiryId, activeContactFilterId }) => {
	const { t } = useTranslation();
	const { searchParams } = usePaginatedList();
	const props = useOpen();
	const { selectedRows, availableItemIds } = useBulkEdit();
	const { resendContactInquiryEmail, closePendingContactUpdateInquiry } = useContactUpdateInquiryContactActions(
		contactUpdateInquiryId,
		activeContactFilterId,
	);

	return (
		<>
			<IconButton
				type="button"
				title={t("Resend contact update inquiry")}
				size="small"
				disabled={selectedRows.length === 0 || availableItemIds.length === 0}
				icon="send"
				onClick={props.handleOpen}
			/>
			<IconButton
				type="button"
				title={t("Mark as completed")}
				size="small"
				disabled={selectedRows.length === 0 || availableItemIds.length === 0}
				icon="check"
				onClick={() => closePendingContactUpdateInquiry(selectedRows, searchParams?.search)}
			/>
			<ConfirmationDialog
				open={props.open}
				onClose={props.handleClose}
				action={() => {
					void resendContactInquiryEmail(selectedRows, searchParams?.search);
					props.handleClose();
				}}
				heading={t("Pending feedback")}
				labels={{ close: t("Close"), confirm: t("Confirm") }}
			>
				{t("Are you sure you want to resend the contact update inquiry?")}
			</ConfirmationDialog>
		</>
	);
};
